import React, { useEffect, useMemo } from 'react';
import {
  Box,
  constants,
  FormContainer,
  FormInput,
  Text,
  Title,
} from '@thecb/components';
import { hasLength } from 'redux-freeform';
import {
  voidFormReducer,
  voidFormMapStateToProps,
  voidFormMapDispatchToProps,
} from './OrderDetailsVoidModal.state';
import { PAYMENT_TYPE, TRANSACTION_STATUS } from '../../utils/constants';
import { formatPrice } from '../../utils/helpers';

const notesErrors = {
  [hasLength.error]: 'Character limit exceeded (250)',
};

const VoidForm = ({
  actions,
  fields,
  orderContainsCashPayments,
  transactionsForOrder,
}) => {
  useEffect(() => {
    return () => actions.form.clear();
  }, []);
  const totalCashToVoid = useMemo(
    () =>
      transactionsForOrder
        ?.filter(
          (transaction) =>
            transaction?.payment_type === PAYMENT_TYPE.CASH_PAYMENT &&
            transaction?.status === TRANSACTION_STATUS.SUCCESSFUL,
        )
        .reduce((acc, cur) => (acc += cur.amount_processed), 0),
    [transactionsForOrder],
  );

  const voidText = (
    <Box padding="0px" extraStyles={`text-align: center;`}>
      <Text variant="p">
        {`Are you sure you want to void this order? ${
          orderContainsCashPayments
            ? 'This order contains cash. To complete this void the below amount of cash will need to be returned.'
            : ''
        }`}
      </Text>
      {orderContainsCashPayments && (
        <Title
          as="h3"
          margin="8px 0px 0px 0px"
          weight={constants.fontWeights.FONT_WEIGHT_BOLD}
        >
          {formatPrice(totalCashToVoid)}
        </Title>
      )}
    </Box>
  );
  return (
    <FormContainer>
      {voidText}
      <hr />
      <FormInput
        data-testid="Notes Test"
        labelTextWhenNoError="Notes"
        field={fields.notes}
        fieldActions={actions.fields.notes}
        errors={fields.errors}
        errorMessages={notesErrors}
        labelTextVariant="p"
        errorTextVariant="p"
      />
    </FormContainer>
  );
};

VoidForm.reducer = voidFormReducer;
VoidForm.mapStateToProps = voidFormMapStateToProps;
VoidForm.mapDispatchToProps = voidFormMapDispatchToProps;

export { VoidForm };
